module.exports = __webpack_public_path__ + "img/vaenquish_cover.43c44331.jpg";